<template>
	<div id="departments">
		<!-- 用户列表卡片区 -->
		<el-card class="box-card" v-if="created_1">
			<ul class="create-list" v-for="item in create_list">
				<li class="create-list-class">
					{{item.className}}
					<i :class="[show?'el-icon-minus':'el-icon-plus']" style="border: 1px solid #000;margin-right: 20px;float: right;margin-top: 8px;" @click="show = !show"></i>
				</li>
				<li @click="choseClick" v-show="show" class="create-list-subClass" v-for="items in item.children">{{items.subClass}}</li>
			</ul>
		</el-card>
		
		<el-card class="box-card" style="margin-top: 20px;" v-if="created_1">
			<ul class="create-list" v-for="item in create_list2">
				<li class="create-list-class">
					{{item.className}}
					<i :class="[show2?'el-icon-minus':'el-icon-plus']" style="border: 1px solid #000;margin-right: 20px;float: right;margin-top: 8px;" @click="show2 = !show2"></i>
				</li>
				<li @click="choseClick" v-show="show2" class="create-list-subClass" v-for="items in item.children">{{items.subClass}}</li>
			</ul>
		</el-card>

		<el-card v-if="!created_1">
			<el-form size="mini" ref="form" :model="sizeForm" label-width="200px">
				<el-form-item label="编号:" :required="true">
					<el-input v-model="sizeForm.name" :style="input_width" disabled></el-input>
				</el-form-item>
				<el-form-item label="部件类型:" prop="region" :required="true">
					<el-select v-model="sizeForm.region" :placeholder="$t('message.placeholder.select')" :style="input_width" @change="">
						<el-option v-for="item in sizeForm_list1" :label='item.name' :value="item.name"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="生命周期阶段:">
					初始
				</el-form-item>
				<el-form-item label="版本发放日期:">

				</el-form-item>
				<el-form-item label="部件类别:">
					<el-select v-model="sizeForm.region" :placeholder="$t('message.placeholder.select')" @change="" :style="input_width">
						<el-option label='半成品' value="半成品"></el-option>
						<el-option label='成品' value="成品"></el-option>
						<el-option label='包装' value="包装"></el-option>
						<el-option label='电子件' value="电子件"></el-option>
						<el-option label='辅料' value="辅料"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="生效日期:">

				</el-form-item>
				<el-form-item label="描述:">
					<el-input type="textarea" v-model="sizeForm.desc" :style="input_width"></el-input>
				</el-form-item>
				<el-form-item label="可发运物件:">
					否
				</el-form-item>
				<el-form-item label="从累积中排除:">
					否
				</el-form-item>
				<el-form-item label="合规计算日期:" style="margin-bottom: 40px;">

				</el-form-item>
				<span>申请人填写CIS相关属性</span>
				<el-divider></el-divider>
				<el-form-item label="器件资料上传:">
					<el-select v-model="sizeForm.region" :placeholder="$t('message.placeholder.select')" @change="" :style="input_width">
						<el-option label='半成品' value="半成品"></el-option>
						<el-option label='成品' value="成品"></el-option>
						<el-option label='包装' value="包装"></el-option>
						<el-option label='电子件' value="电子件"></el-option>
						<el-option label='辅料' value="辅料"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="Value:">

				</el-form-item>
				<el-form-item label="描述:">
					<el-input type="textarea" v-model="sizeForm.desc" :style="input_width"></el-input>
				</el-form-item>
				<el-form-item label="Deveice Description:" style="margin-bottom: 40px;">
					<el-input type="textarea" v-model="sizeForm.desc" :style="input_width"></el-input>
				</el-form-item>

				<span>申请人维护【客户相关信息】</span>
				<el-divider></el-divider>
				<el-form-item label="客户名称:">
					<el-input v-model="sizeForm.name" :style="input_width"></el-input>
				</el-form-item>
				<el-form-item label="客户对应料号:">
					<el-input v-model="sizeForm.name" :style="input_width"></el-input>
				</el-form-item>

				</el-form-item>
				<el-form-item label="客户对应的物料描述:">
					<el-input type="textarea" v-model="sizeForm.desc" :style="input_width"></el-input>
				</el-form-item>
				<!-- 提交按钮 -->
				<el-form-item>
					<el-button type="primary" @click="submitForm2">{{$t('message.button.createNow')}}</el-button>
					<el-button>{{$t('message.button.reset')}}</el-button>
				</el-form-item>
			</el-form>
		</el-card>

	</div>
</template>

<style scoped>
.create-list {
	padding: 0;
	margin: 0;
	overflow: hidden;
}	
.create-list-subClass {
	width: 24%;
	height: 30px;
	float: left;
	text-align: center;
	background: #EBEEF5;
	margin-right: 1%;
	margin-top: 10px;
	line-height: 30px;
}
.create-list-subClass:hover {
	cursor: pointer;
	background: #409EFF;
	color: #FFF;
}
.create-list .create-list-class {
	width: 96%;
	background: rgb(198, 226, 255);
	text-align: left;
	height: 38px;
	line-height: 38px;
	font-size: 18px;
	cursor: default;
	padding-left: 3%;
}
</style>

<script>
	import axios from "axios";
	export default {
		data() {
			return {
				show:true,
				show2:true,
				create_list: [{
						className:"工程文档",
						children:[{
							subClass:"测试报告"
						},{
							subClass:"测试样机"
						},{
							subClass:"产品规格书"
						},{
							subClass:"生产软件"
						},{
							subClass:"样机登记单"
						},{
							subClass:"质量计划"
						},{
							subClass:"作业指导书"
						},{
							subClass:"供应商开模协议"
						}],
					}],
					
				create_list2: [{
						className:"项目文档",
						children:[{
							subClass:"规范类"
						},{
							subClass:"技术协议、合同"
						},{
							subClass:"跨部门文件"
						},{
							subClass:"培训资料"
						},{
							subClass:"项目管理文件"
						},{
							subClass:"证书类"
						},{
							subClass:"报告类"
						},{
							subClass:"报价类"
						},{
							subClass:"成本类"
						},{
							subClass:"规范类"
						},{
							subClass:"合同评审表"
						},{
							subClass:"客户开模协议"
						},{
							subClass:"模板"
						},{
							subClass:"外来文件"
						},{
							subClass:"项目管理类"
						}],
					}],

				create_list3: [{
						className:"技术文档",
						children:[{
							subClass:"电路设计图"
						},{
							subClass:"源代码"
						},{
							subClass:"异常追踪"
						}],
					}],
				created_1: true, //创建首页显示
				input_width: {
					width: "50%"
				},

				sizeForm: { //第二个表单
					Num: '',
					region: '',
					date1: '',
					date2: '',
					delivery: false,
					type: [],
					resource: '',
					desc: ''
				},
				sizeForm_list1: [{
					name: "[ATL]电解液"
				}, {
					name: "[ATL]成品"
				}, {
					name: "[ATL]电量计"
				}, {
					name: "[ATL]溶剂"
				}, {
					name: "[ATL]工艺"
				}, {
					name: "[ATL]搅拌工艺"
				}, {
					name: "川润工艺"
				}, {
					name: "海大成品"
				}, {
					name: "上等烟叶"
				}, {
					name: "成品-内存"
				}],

				ruleForm: {
					name: '111',
					region: ''
				},
				chose_lists: [{
					name: "[ATL]电解液"
				}, {
					name: "[ATL]成品"
				}, {
					name: "[ATL]电量计"
				}, {
					name: "[ATL]溶剂"
				}, {
					name: "[ATL]工艺"
				}, {
					name: "[ATL]搅拌工艺"
				}, {
					name: "川润工艺"
				}, {
					name: "海大成品"
				}, {
					name: "上等烟叶"
				}, {
					name: "成品-内存"
				}],
				rules: {
					region: [{
						required: true,
						message: '请选择活动区域',
						trigger: 'change'
					}],
				}
			};
		},
		methods: {
			selectOne(event, item) { //change 触发事件
				//直接就拿到当前的这个对象了
				this.ruleForm.name = event;
				this.sizeForm.name = event;
			},
			listClick: function() {
				//alert("1");
				//console.log(this.ruleForm.region);
			},
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.created_1 = false;
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			submitForm2() {
				this.$message({
					title: "创建成功",
					message: "创建成功",
					type: "success"
				});
				this.$router.push("/document");
			},
			choseClick() {
				this.created_1 = !this.created_1;
			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
			}

		},
		created() {
			// setTimeout(() => {
			// 	this.loading = false;
			// }, 500);
		}
	};
</script>
